module.exports = __webpack_public_path__ + "static/media/mco.ce438187.svg";